import { put, takeLatest, call } from "redux-saga/effects";
import {
	loginAsync,
	LoginAsyncPayload,
	logoutAsync,
	setAuth,
	getMyProfileAsync,
	setMyProfile,
	TokenInfo,
	GetMyProfilePayload,
} from "./authSlice";
import { uuid } from "short-uuid";
import { message } from "antd";
import { setLoadingPage } from "store/app/app.slice";
import api from "service/apiService";
import { translate } from "utils";
import { PayloadAction } from "@reduxjs/toolkit";
import { Staff } from "features/staff/types";
import { ApiResponse } from "types";
import { LOCAL_KEY } from "constants/key";
import { handleUnregisterServiceWorkers } from "utils/service-worker";

function* loginSaga(action: PayloadAction<LoginAsyncPayload>) {
	yield put({ type: setLoadingPage.type, payload: true });
	const { response, error } = yield call(async () => {
		try {
			localStorage.setItem(LOCAL_KEY.deviceId, `${uuid()}_3`);
			const { data: response } = await api.post<
				ApiResponse<{
					user: Staff;
					tokenInfo: TokenInfo;
					permissions: string[];
				}>
			>("/staff/login", action.payload);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		const { tokenInfo, permissions, user } = response.data;
		yield put({
			type: setAuth.type,
			payload: {
				...tokenInfo,
			},
		});
		yield put({
			type: setMyProfile.type,
			payload: { ...user, permissions: [...permissions] },
		});
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoadingPage.type, payload: false });
}

function* watchLogin() {
	yield takeLatest(loginAsync, loginSaga);
}

//Logout
function* logoutSaga() {
	yield put({ type: setLoadingPage, payload: true });
	try {
		api.post(
			"/staff/logout",
			{}
		);
		localStorage.removeItem(LOCAL_KEY.deviceId);
		handleUnregisterServiceWorkers();
		yield put({ type: setLoadingPage.type, payload: false });
	} catch (error) {
		return { error };
	}
	
}

function* watchLogout() {
	yield takeLatest(logoutAsync, logoutSaga);
}

// Get profile
function* getMyProfileSaga(action: PayloadAction<GetMyProfilePayload>) {
	// yield put({ type: setLoadingPage.type, payload: true });
	const { returnAction } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/staff/my-profile", {});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setMyProfile.type, payload: response.data.data });
		returnAction && returnAction();
	} else {
		message.error(translate(error.message));
	}
	// yield put({ type: setLoadingPage.type, payload: false });
}
function* watchGetMyProfile() {
	yield takeLatest(getMyProfileAsync, getMyProfileSaga);
}

const authSaga = [watchLogin(), watchLogout(), watchGetMyProfile()];
export default authSaga;
